var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_c('div',{staticClass:"container mx-auto px-4"},[_c('book-nav'),(_vm.user)?_c('admin-notes-resource',{attrs:{"action":"update"}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }